<template>
  <v-row class="fill-height" no-gutters v-if="innerCandidates">
<!--    <div style="position: absolute; height: 100vh; width: 1px; top: 0; left: 50%; background-color: red;"></div>-->
    <v-col cols="12">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="auto">
          <div class="display-3 white--text">
            {{ hasSelectedCandidate ? innerCandidates[selectedCandidateIndex].name : 'Welcome' }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" style="height: 600px">
          <v-row ref="candidateRow" justify="center" class="flex-nowrap fill-height flex-row" style="padding-top: 200px;" no-gutters>
            <v-col ref="candidateRef"
                   class="pa-6"
                   cols="auto"
                   :key="index"
                   v-for="(candidate, index) in innerCandidates"
            >
              <candidate-avatar
                  :selected="candidate.selected"
                  :was-selected="candidateIsSelected(candidate)"
                  :inSelection="inSelection"
                  :profilePicHeight="candidates.length > 6 ? 130 : 170"
                  :profilePicWidth="candidates.length > 6 ? 130 : 170"
                  :candidate="candidate"
                  :hide-names="hideNames"
                  :progression="progression"
              ></candidate-avatar>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center">
            <v-col cols="auto">
              <v-btn
                  color="white"
                  outlined
                  class="rounded-lg"
                  :disabled="!canSelect || selectedCandidates.length === innerCandidates.length"
                  :dark="!canSelect || selectedCandidates.length === innerCandidates.length"
                  v-if="!canAcceptSelection"
                  @click="setState(true)"
              >Select Candidate
              </v-btn>
            </v-col>
            <v-col cols="auto" class="pr-2" v-if="canAcceptSelection">
              <v-btn
                  outlined
                  class="rounded-lg"
                  color="white"
                  @click="moveToNextCandidate(true)"
              >Cancel
              </v-btn>
            </v-col>
            <v-col cols="auto" class="pl-2" v-if="canAcceptSelection">
              <v-btn
                  color="white"
                  outlined
                  class="rounded-lg"
                  @click="moveToNextCandidate()"
              >Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import CandidateAvatar from "@/views/Tools/GeneralTools/Components/CandidateAvatar";

export default {
  name: "CandidateSelector",
  components: {
    CandidateAvatar
  },
  props: {
    candidates: {
      type: Array,
      required: true,
    }
  },
  computed: {
    unselectedCandidates() {
      return this.innerCandidates.filter(candidate => !this.selectedCandidates.includes(candidate.personid));
    },
    selectedCandidateIndex() {
      if (this.innerCandidates) {
        return this.innerCandidates.findIndex(candidate => candidate.selected);
      }

      return -1;
    },
    hasSelectedCandidate() {
      return this.selectedCandidateIndex !== -1;
    },
  },
  data: () => ({
    innerCandidates: null,
    selectedCandidates: [],
    inSelection: false,
    canSelect: true,
    canAcceptSelection: false,
    hideNames: false,
    progression: 0,
    animating: false,
    screenWidth: null,
  }),
  methods: {
    setCandidates() {
      this.innerCandidates = JSON.parse(JSON.stringify(this.candidates.map((candidate) => {
        return {
          ...candidate,
          selected: false,
        };
      })));
    },
    cycleThroughCandidates(candidate, candidateIndex) {
      if (this.unselectedCandidates.length > 1) {
        let index = 0,
            counter = 0,
            loops = 2,
            intervalTime = 250,
            timeoutTime = 240,
            totalTicks = candidateIndex > 0 ? (((this.unselectedCandidates.length * loops)) + candidateIndex) - 1 : (this.unselectedCandidates.length * loops) - 1;

        const interval = setInterval(() => {
          this.$set(this.unselectedCandidates[index], 'selected', true);
          setTimeout(() => {
            if (this.unselectedCandidates[index]) {
              this.$set(this.unselectedCandidates[index], 'selected', false);
            }

            if (index === this.unselectedCandidates.length - 1) {
              index = 0;
            } else {
              index++;
            }

            if (counter === totalTicks) {
              clearInterval(interval);
              this.selectLocalCandidate(candidate.personid);
              setTimeout(() => {
                this.goToSelectedView();
              }, 1000);
            } else {
              counter++;
            }
          }, timeoutTime);
        }, intervalTime);
      } else {
        this.selectLocalCandidate(this.unselectedCandidates[0].personid);
        this.canAcceptSelection = true;
      }
    },
    candidateIsSelected(candidate) {
      return this.selectedCandidates.includes(candidate.personid);
    },
    setState(selecting = false) {
      this.$emit('animating', true);

      this.canSelect = false;
      this.inSelection = selecting;
      if (selecting) {
        this.selectRandomCandidate();
      }
    },
    selectRandomCandidate() {
      const random = Math.floor(Math.random() * this.unselectedCandidates.length);
      this.cycleThroughCandidates(this.unselectedCandidates[random], random);
    },
    selectLocalCandidate(id) {
      const selected = this.unselectedCandidates.find(({personid}) => personid === id);

      if (selected) {
        selected.selected = true;
      }
    },
    selectMainCandidate(id) {
      this.selectedCandidates.push(id);
    },
    resetLocalSelected() {
      if (this.innerCandidates) {
        this.innerCandidates.forEach((candidate) => this.$set(candidate, 'selected', false));
      }
    },
    resetMainSelected() {
      this.resetLocalSelected();
      this.selectedCandidates = [];
    },
    goToSelectedView() {
      this.animating = true;
      this.hideNames = true;

      const candidateRow = this.$refs.candidateRow,
          selectedCandidate = this.$refs.candidateRef[this.selectedCandidateIndex],
          screenMiddlePoint = this.screenWidth / 2,
          centerTranslate = (-((selectedCandidate.offsetLeft - (selectedCandidate.offsetWidth)) - screenMiddlePoint) / 3) - (this.candidates.length > 6 ? 89 : 109);

      if (candidateRow && selectedCandidate) {
        candidateRow.style.transition = 'all 0.2s ease-in-out';
        candidateRow.style.transform = 'scale(0.5) translateY(350px)';

        setTimeout(() => {
          selectedCandidate.style.transition = 'transform 0.2s ease-in-out';
          selectedCandidate.style.transform = `scale(3) translate(${centerTranslate}px, -100px)`;

          this.canAcceptSelection = true;

          for (let i = 0; i < 100; i++) {
            setTimeout(() => {
              this.progression++;
            }, 50)
          }

        }, 750);
      }

      this.canAcceptSelection = false;
    },
    moveToNextCandidate(cancel = false) {
      if (this.innerCandidates && this.hasSelectedCandidate) {
        this.canAcceptSelection = false;
        this.animating = true;

        const candidateRow = this.$refs.candidateRow;
        const selectedCandidate = this.$refs.candidateRef[this.selectedCandidateIndex];

        if (candidateRow && selectedCandidate) {
          selectedCandidate.style.transform = '';

          setTimeout(() => {
            if (!cancel) {
              this.selectMainCandidate(this.innerCandidates[this.selectedCandidateIndex].personid);
            }
            this.innerCandidates[this.selectedCandidateIndex].selected = false;
          }, 500);
          setTimeout(() => {
            candidateRow.style.transform = '';
          }, 1000);
          setTimeout(() => {
            this.resetAllStates();
          }, 1200);
        }
      }
    },
    resetAllStates() {
      this.inSelection = false;
      this.canSelect = true;
      this.animating = false;
      this.hideNames = false;
      this.progression = 0
      this.$emit('animating', false);
    },
    setScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  mounted() {
    this.setScreenWidth();
    document.addEventListener('resize', this.setScreenWidth);
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.setScreenWidth);
  },
  watch: {
    candidates(val) {
      if (val.length > 0) {
        this.setCandidates();
      }
    },
  },
}
</script>

<style scoped>
</style>